
import createIconComponent from '../utils/createIconComponent';
import { SVG_GOTO_WHITE_YELLOW } from '../../../dist';
import React from 'react';
const GotoWhiteYellowIcon = createIconComponent({ content: SVG_GOTO_WHITE_YELLOW, height: 24, width: 49 });
GotoWhiteYellowIcon.displayName = 'GotoWhiteYellowIcon';
export default GotoWhiteYellowIcon;
